import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Root page
 */
export default function Page() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/home', { replace: true, state: { skipLoading: true } });
  }, []);

  return null;
}
